import jsPDF from "jspdf";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";

const handleQuickTable = (
  quickArray,
  dispatch,
  updateLevel2Properties,
  Sheetid
) => {
  // console.log(quickArray);
  if (quickArray.length) {
    dispatch(
      updateLevel2Properties({
        reduxKey: "quickTable",
        Sheetid: Sheetid,
        parentKey: "actions",
        value: quickArray,
        itemInArray: false,
        index: null,
      })
    );
  }
};
const handleNumberObjectForQuickTable = (
  index,
  updatedItem,
  dispatch,
  updateLevel2Properties,
  Sheetid
) => {
  dispatch(
    updateLevel2Properties({
      reduxKey: "valueColumns",
      Sheetid: Sheetid,
      parentKey: "query",
      value: updatedItem,
      itemInArray: true,
      index: index,
    })
  );
};

const findMatchedItems = (mergedArray, sortArray) => {
  // // console.log(mergedArray);
  // // console.log(sortArray);

  if (sortArray.length === 0) {
    let firstItemIndex = 0;
    const firstItem = mergedArray[firstItemIndex];
    return [firstItem];
  } else {
    const filteredSortArray = sortArray.filter((sortItem) =>
      mergedArray.some((mergedItem) => mergedItem.uuid === sortItem.uuid)
    );
    if (filteredSortArray.length === sortArray.length) {
      return filteredSortArray;
    } else {
      console.error(
        "Some items in sortArray were not present in mergedArray, returning filtered list."
      );
      return filteredSortArray;
    }
  }
};
function getDateUnitFormat(dateUnit) {
  const formats = {
    Years: "%Y",
    Quarter: "%Q",
    Months: "%M",
    Days: "%d",
    Weeks: "%W",
  };

  return formats[dateUnit] || null; // Return null for unsupported values
}

const breakValue = (input, calledFrom) => {
  // console.log(input);
  const parts = input.split(" ");
  // console.log(input.split(" "));

  // console.log(parts.length === 3);
  // console.log(calledFrom);

  if (parts.length === 3) {
    // console.log(parts[0]);
    // console.log(parts[1]);
    // console.log(parts[2]);

    return {
      period: parts[0], // "last"
      value: parts[1], // "5"
      unit: parts[2], // "days"
    };
  }
  if (
    (parts.length === 2 && calledFrom === "dateConfigComp") ||
    (parts.length === 2 && calledFrom === "aside3SideBar")
  ) {
    // console.log("hi");

    if (parts[0] === "Last") {
      return {
        period: 0,
        value: undefined,
        unit: parts[1],
      };
    } else if (parts[0] === "This") {
      return {
        period: 1,
        value: undefined,
        unit: parts[1],
      };
    } else if (parts[0] === "Next") {
      return {
        period: 2,
        value: undefined,
        unit: parts[1],
      };
    } else {
      return false;
    }
  }
  if (parts.length === 2 && calledFrom === "buildQuery") {
    return false;
  }
  if (
    (parts.length === 1 && calledFrom === "dateConfigComp") ||
    (parts.length === 1 && calledFrom === "aside3SideBar")
  ) {
    // console.log(input);
    if (["Yesterday", "Today", "Tomorrow"].includes(input)) {
      if (input === "Today") {
        return {
          period: 1,
          value: undefined,
          unit: "Days",
        };
      }
      if (input === "Yesterday") {
        return {
          period: 0,
          value: undefined,
          unit: "Days",
        };
      }
      if (input === "Tomorrow") {
        return {
          period: 2,
          value: undefined,
          unit: "Days",
        };
      }
    }
  }
};

// function findSubCategoriesByCategory(category, data, dataObject) {
function findSubCategoriesByCategory({
  headingValue,
  xAxis,
  dimension,
  mainData,
  dataObject,
  metricVales,
}) {
  const subCategories = mainData
    .filter((item) => item[xAxis] === headingValue)
    .map((item) => item[dimension]); // Extract the sub-category

  // Step 2: Filter keys from dataObject that match the sub-categories
  const filteredValues = Object.keys(dataObject)
    .filter((key) => {
      const subCategory = key.split("|")[0]; // Extract sub-category from keys like 'Phones|SUM_Sales'
      return subCategories.includes(subCategory) || key.startsWith("Total"); // Check if sub-category exists in the list
    })
    .reduce((result, key) => {
      result[key] = dataObject[key]; // Include matching key-value pairs in the result
      return result;
    }, {});

  return {
    subCategories: subCategories.length && subCategories,
    filteredValues,
  };
}

function splitKeys(value) {
  if (value) {
    const valueWithOutPipe = value.split("|");
    // console.log(valueWithOutPipe);
    return valueWithOutPipe[0];
  }
  return null;
}
const handleFilterInDashboard = ({
  item,
  dashIDs,
  dispatch,
  setCommonFilters,
}) => {
  // console.log(item.rename);

  let updatedDashboardIDs;
  if (item.dashboardIDs) {
    const dashboardIDsArray = Array.isArray(item.dashboardIDs)
      ? item.dashboardIDs
      : [];
    // console.log(dashboardIDsArray);
    updatedDashboardIDs = dashboardIDsArray.includes(dashIDs)
      ? dashboardIDsArray.filter((id) => {
          return id !== dashIDs;
        }) // Remove dashIDs if it exists
      : null;
  }
  // console.log({ ...item, dashboardIDs: updatedDashboardIDs });

  dispatch(
    setCommonFilters({
      value: { ...item, dashboardIDs: updatedDashboardIDs },
      operation: "UPDATE",
      Sheetid: item.Sheetid,
    })
  );
};

const buildSortObject = (vizType, groupByKeys, rowKeys) => {
  let sortObject = null;
  const groupZeroIndexItem = groupByKeys[0];
  const rowZeroIndexItem = rowKeys[0];
  switch (vizType) {
    case "cordinatemap":
      sortObject = { isRandomSort: true };
      break;
    case "simpleTable":
      if (rowKeys.length && groupByKeys.length === 0) {
        if (rowZeroIndexItem.dataType === "Date") {
          sortObject = {
            columnName: rowZeroIndexItem.columnName,
            order: "ASC",
            format: rowZeroIndexItem.format,
          };
        }
        if (rowZeroIndexItem.dataType === "String") {
          sortObject = {
            columnName: rowZeroIndexItem.responseKey,
            order: "ASC",
            format: rowZeroIndexItem.format,
          };
        }
      } else {
        console.error("rows array is empty");
      }
    case "piechart":
    case "linechart":
    case "areachart":
    case "stackedbarchart":
    case "scatterchart":
    case "combochart":
    case "stackedbarchartimage":
      if (groupByKeys.length && rowKeys.length === 0) {
        if (groupZeroIndexItem.dataType === "Date") {
          sortObject = {
            columnName: groupZeroIndexItem.columnName,
            order: "ASC",
            format: groupZeroIndexItem.format,
          };
        }
        if (groupZeroIndexItem.dataType === "String") {
          sortObject = {
            columnName: groupZeroIndexItem.responseKey,
            order: "ASC",
            format: groupZeroIndexItem.format,
          };
        }
      }
    default:
      break;
  }
  // console.log(sortObject);
  if (sortObject) {
    return [sortObject];
  } else {
    return [];
  }
};
const downloadDataAsCSV = (data, SheetName) => {
  if (!data || data.length === 0) return;

  const keys = Object.keys(data[0]);
  const csvContent = [
    keys.join(","), // Header row
    ...data.map((row) =>
      keys
        .map((key) => (row[key] !== undefined ? `"${row[key]}"` : ""))
        .join(",")
    ),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, `exported-data-${SheetName}-${Date.now()}.csv`);
};
const takeAndDownloadScreenshotForEchart = async (
  imageFormat,
  componentRef,
  SheetName,
  sheetType
) => {
  if (componentRef.current) {
    setTimeout(async () => {
      const canvas = await html2canvas(componentRef.current, {
        useCORS: true,
        allowTaint: true,
        logging: true,
      });

      if (imageFormat === "jpg") {
        const link = document.createElement("a");
        link.download = `${SheetName}-screenshot.jpg`;
        link.href = canvas.toDataURL("image/jpeg");
        link.click();
      } else if (imageFormat === "pdf") {
        const imgData = canvas.toDataURL("image/jpeg");
        let format = sheetType === "chart" ? "a4" : "a3";
        const pdf = new jsPDF("landscape", "mm", format);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        // Get the image's natural size
        const imgProps = pdf.getImageProperties(imgData);
        const imgWidth = imgProps.width;
        const imgHeight = imgProps.height;

        // Scale the image to fit within PDF bounds
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
        const newWidth = imgWidth * ratio;
        const newHeight = imgHeight * ratio;

        const x = (pdfWidth - newWidth) / 2;
        const y = (pdfHeight - newHeight) / 2;

        pdf.addImage(imgData, "JPEG", x, y, newWidth, newHeight);
        pdf.save(`${SheetName}-screenshot.pdf`);
      }
    }, 500); // slight delay to ensure everything is rendered
  }
};
const takeAndDownloadScreenshotForRechart = async (
  screenshotFunction,
  requiredSheetId,
  imageFormat,
  workbook_ID,
  sheetType,
  nonActiveSheetFilters,
  sheetsWithActivity,
  currentState
) => {
  // Get the current Redux state
  // const currentState = store.getState().Workbook.present;
  if (!requiredSheetId) {
    console.error(`${requiredSheetId} is null or undefined`);
    return;
  }
  // console.log("screenshot", screenshotFunction);

  if (!screenshotFunction || typeof screenshotFunction !== "function") {
    console.error("Screenshot function is not available or not a function");
    return;
  }

  // const body = {
  //   workbookId: workbook_ID,
  //   sheetid: requiredSheetId,
  //   sheetType: sheetType,
  //   downloadType: imageFormat,
  //   filters: nonActiveSheetFilters,
  //   activeSheet:
  //     Array.isArray(sheetsWithActivity) && sheetsWithActivity.length
  //       ? sheetsWithActivity[0]
  //       : null,
  // };
  // // console.log("Screenshot request body:", body);
  if (currentState) {
    const isValidFilters =
      Array.isArray(nonActiveSheetFilters) && nonActiveSheetFilters.length;
    // // console.log(nonActiveSheetFilters);
    const activeSheetArray = Array.isArray(sheetsWithActivity)
      ? sheetsWithActivity.map((s) => {
          return {
            activeSheetId: s.Sheetid,
            activeIndex: s.activeIndex,
            activeBarIndex: s.activeBarIndex,
            stackActiveIndex: s.stackActiveIndex,
            clickedValues: s.clickedValues,
          };
        })
      : [];
    const body = {
      workbookId: currentState["_id"],
      workbookObject: currentState,
      activeFilters: isValidFilters ? nonActiveSheetFilters : [],
      activeSheet: activeSheetArray,
      sheetid: requiredSheetId,
      sheetType: sheetType,
      downloadType: imageFormat,
    };
    // console.log(body);
    try {
      const response = await screenshotFunction(body).unwrap();
      // console.log("Screenshot response:", response);

      const screenshotURL = response?.screenshots?.[0]?.screenshotURL;
      if (!screenshotURL) {
        console.error("Screenshot URL not found in response:", response);
        return;
      }

      if (response?.downloadType === "jpg") {
        const imageResponse = await fetch(screenshotURL);
        const blob = await imageResponse.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "screenshot.png"; // Customize file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else if (response?.downloadType === "pdf") {
        try {
          const base64Image = screenshotURL;
          let format = "a3";
          const pdf = new jsPDF({
            orientation: "landscape",
            unit: "mm",
            format: format,
          });

          // Add the image to the PDF: (imageData, format, x, y, width, height)
          pdf.addImage(base64Image, "PNG", 10, 10, 400, 280);

          // Automatically trigger download
          pdf.save("converted-image.pdf");
        } catch (err) {
          console.error("Failed to download PDF:", err);
        }
      }
    } catch (error) {
      console.error("Failed to download screenshot:", error);
    }
  }
};

export {
  handleQuickTable,
  handleNumberObjectForQuickTable,
  findMatchedItems,
  breakValue,
  getDateUnitFormat,
  findSubCategoriesByCategory,
  splitKeys,
  handleFilterInDashboard,
  buildSortObject,
  downloadDataAsCSV,
  takeAndDownloadScreenshotForEchart,
  takeAndDownloadScreenshotForRechart,
};
